import { Grid, IconButton, Tooltip } from '@mui/material'
import { useCallback, useContext, useEffect, useState } from 'react'
import { MdAdd, MdArrowBack } from 'react-icons/md'
import { GlobalContext } from '../../../App'
import Programa from '../../../components/Programa/Programa'
import { metodoPrograma } from '../../../components/api'
import Edicao from './Edicao'
import PrimeTable from '../../../components/PrimeTable'

const FluxoAtendimento = () => {
  const { localAtendimento } = useContext(GlobalContext)

  const [tela, setTela] = useState('lista')
  const [ferramentas, setFerramentas] = useState()
  const [dados, setDados] = useState(null)
  const [refresh, setRefresh] = useState(0)

  const exclui = useCallback((dados) => {
    metodoPrograma('exclui', { idFluxoAtendimento: dados[0] }).then((res) => {
      if (res.status) {
        setRefresh((prev) => prev + 1)
      }
    })
  }, [])

  const voltar = useCallback(() => {
    setTela('lista')
    setDados(undefined)
  }, [])

  const handleClick = (linha) => {
    setDados(linha)
    setTela('opcoes')
  }

  useEffect(() => {
    switch (tela) {
      case 'lista':
        setFerramentas(
          <Tooltip title="Adicionar">
            <IconButton onClick={() => setTela('opcoes')}>
              <MdAdd />
            </IconButton>
          </Tooltip>,
        )
        break
      case 'opcoes':
        setFerramentas(
          <Tooltip title="Voltar">
            <IconButton onClick={voltar}>
              <MdArrowBack />
            </IconButton>
          </Tooltip>,
        )
        break
      default:
        break
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tela])

  return (
    <Programa codigo="CtrlFluxoAtendimento" ferramentas={ferramentas}>
      {tela === 'lista' ? (
        <Grid container spacing={2}>
          <Grid item xs={12}>
            {localAtendimento !== undefined && localAtendimento !== null && (
              <PrimeTable
                codigo="CtrlFluxoAtendimento"
                action="lista"
                rows={10}
                habSearch
                head={['Título', 'Exclusao']}
                line={(item) => [item[1], item[2]]}
                collumnsDateHour={[1]}
                onRowSelect={handleClick}
                onDelete={{ index: 1, action: exclui }}
                refresh={refresh}
              />
            )}
          </Grid>
        </Grid>
      ) : (
        <Edicao {...{ dados, voltar }} />
      )}
    </Programa>
  )
}

export default FluxoAtendimento
